import { components, useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { contextSelectorQueryKeys } from "./queryKeys";

export function useFilteredContextOptions({
  fields,
  filters,
  enabled
}: {
  fields?: components["schemas"]["ContextField"][];
  filters?: components["schemas"]["ContextOptionsInput"]["filters"];
  enabled?: boolean;
}) {
  const client = useApi();

  return useQuery({
    queryKey: contextSelectorQueryKeys.list(
      JSON.stringify({ fields, filters })
    ),
    queryFn: async () => {
      try {
        const response = await client.POST(
          "/v1/context-options/getContextOptions",
          {
            body: {
              fields: fields || [],
              filters: filters || {}
            }
          }
        );

        return response.data?.result ?? {};
      } catch (error) {
        console.error("Error fetching context options:", error);

        throw error; // Let TanStack Query handle the error state
      }
    },
    enabled: enabled
  });
}
